<template>
    <div>
        <div class="panel">
            <panels />
        </div>
        <div class="progress-wrapper">
            <div class="progress">
                <div class="progress-bar progress-bar-striped" role="progressbar" :style="{width: percentage + '%'}" :aria-valuenow="percentage" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import Panels from "./Panels";

    export default {
        name: 'Questionary',
        components: {
            Panels
        },
        data() {
            return {
                percentage: 0,
            }
        },
        watch: {
            getPanel: {
                immediate: true,
                handler(newPanel) {
                    // this.$options.session.save(this);

                    // Save state in URL
                    if (window.history.pushState) {
                        window.history.pushState({id: newPanel}, document.title, '#' + newPanel.toLowerCase());
                    } else {
                        window.hash = '#' + newPanel;
                    }

                    this.setPercentage(newPanel);
                }
            }
        },
        computed: {
            ...mapGetters([
                'getPanel'
            ])
        },
        session: {
            /**
             * Storage name
             */
            name: 'cf_questionary',
            /**
             * List data properties to store
             */
            store: [
                'user',
                'panelHistory'
            ],
        },
        methods: {
            setPercentage(newPanel) {
                let panels = Object.keys(this.$options.components.Panels.components);

                this.currentPanelCount = panels.indexOf(newPanel);
                this.panelCount = panels.length;

                this.percentage = (100 * (this.currentPanelCount / this.panelCount)).toFixed(2);
            }
        }
    };
</script>